import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import React, { useMemo } from 'react';
import { isDark } from '../common/utils';
import { CarouselButton } from './carousel-button';
import styles from './carousel-track.module.scss';
import rootStyles from './carousel.module.scss';
const CarouselTrack = ({ length, handleSelection, activeIndex, direction, onNext, onPrevious, hidePrevious, hideNext, focusable, size, }) => {
    const isDarkMode = useMemo(() => isDark(), []);
    const carouselTrackClass = useMemo(() => classNames([
        styles.track,
        direction === 'horizontal'
            ? styles.track_horizontal
            : styles.track_vertical,
    ]), []);
    const carouselContainerClass = useMemo(() => classNames([
        rootStyles.track_wrapper,
        direction === 'horizontal'
            ? styles.track_wrapper_horizontal
            : styles.track_wrapper_vertical,
        // [styles[`track-wrapper-${direction}`]]: true,
    ]), [direction]);
    return (_jsxs("div", { className: carouselContainerClass, children: [_jsx(CarouselButton, { onClick: onPrevious, position: "left", hide: hidePrevious, direction: direction, focusable: focusable, label: "Previous", size: size }), _jsx("ul", { className: carouselTrackClass, role: "list", children: Array.from({ length }).map((_, index) => (_jsx("li", { role: "listitem", className: classNames([
                        styles.track_item,
                        index === activeIndex ? styles.track_item_selected : '',
                        isDarkMode ? styles.dark : '',
                    ]), onClick: () => handleSelection(index) }, index))) }), _jsx(CarouselButton, { onClick: onNext, position: "right", hide: hideNext, direction: direction, focusable: focusable, label: "Next", size: size })] }));
};
export { CarouselTrack };
